// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "mainSite." + "main" + "." + "256ab78909de31f25fdc" + ".css";
};